(() => {
 const subject = document.querySelector('[data-df-subject]');
 if (subject) document.querySelectorAll('form input[name="q"]').forEach(input => {
  if (!subject.contains(input)) input.value = '';
 });
 const init = scope => scope.querySelectorAll('[data-df-root]').forEach(root => {
  if (root.dataset.dfReady) return;
  root.dataset.dfReady = 'true';
  root.querySelectorAll('[data-df-video]').forEach(box => {
   const button = box.querySelector('[data-df-play]');
   const fallback = box.querySelector('.hb-df-video-fallback');
   if (!button || !fallback || !/^[a-zA-Z0-9_-]{11}$/.test(box.dataset.dfVideo)) return;
   button.hidden = false;
   fallback.querySelector('.hb-df-play').hidden = true;
   fallback.setAttribute('tabindex', '-1');
   fallback.setAttribute('aria-hidden', 'true');
   button.addEventListener('click', () => {
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(box.dataset.dfVideo) + '?autoplay=1&playsinline=1&cc_load_policy=1';
    frame.title = box.dataset.dfTitle;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    box.replaceChildren(frame);
    frame.focus();
   }, {once: true});
  });
 });
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
